import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http, Headers, RequestOptions } from '@angular/http';
import firebase from 'firebase/app';
import { LoanAdminPage } from '../loan-admin/loan-admin';
import { controlNameBinding } from '@angular/forms/src/directives/reactive_directives/form_control_name';
import {EnvDataService} from '../../app/services/env-data-service';

@Component({
  selector: 'page-add-loan-admin',
  templateUrl: 'add-loan-admin.html',
  providers:[EnvDataService]
})
export class AddLoanAdminPage {
  @Input('data-name') identifier: string;

  addLoanAdminForm: FormGroup;
    public form_name: any;
    public uid: any;
    public firstname: any;
    public lastname: any;
    public email: any;
    public mobile_phone: any;
    public assigned_broker: any;
    public getRole: any;
    public header_title: any;
    public edit_contact_uid : any;
    public allBrokers: any;

    public selectedBrokers: any;

    public validation_messages = {
      'firstname': [
          { type: 'required', message: 'Firstname is required.' }
      ],
      'lastname': [
        { type: 'required', message: 'Lastname is required.' }
      ],
      'email': [
        { type: 'required', message: 'Email is required.' }
      ],
      'mobile_phone': [
        { type: 'required', message: 'Mobile Number is required.' },
        { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
        { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
      ],
      'password': [
        { type: 'required', message: 'Password is required.' },
        { type: 'minlength', message: 'Password must be at least 6 characters long.' },
        { type: 'maxlength', message: 'Password cannot be more than 20 characters long.' },
      ],
      'assigned_broker': [
        { type: 'required', message: 'Choose borkers is required.' }
      ]
    }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public afs: AngularFirestore,
    public modalCtrl: ModalController,
    public afAuth:AngularFireAuth,
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    public db: AngularFirestore,
    private EnvDataService:EnvDataService
  ) {
    this.form_name = "eLINK Finance";
    this.header_title = "Add Loan Admin";
    this.addLoanAdminForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: ['', Validators.compose([Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(10)])],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(20)])],
      assigned_broker: ['', Validators.compose([Validators.required])]
    });

    this.edit_contact_uid = this.navParams.get("edit_contact_uid");
    let thiss = this;
    if(this.edit_contact_uid == null || this.edit_contact_uid == undefined || this.edit_contact_uid == ""){}else{
      this.header_title = "Update Loan Admin";
      let gpassword = this.addLoanAdminForm.get('password');
      gpassword.setValidators(null);
      gpassword.updateValueAndValidity();
      window.localStorage.setItem("contact_uid", this.edit_contact_uid);
      let docRef1 = firebase.firestore().collection("users").doc(this.edit_contact_uid);
      docRef1.get().then(function(doc) {
        if (doc.exists) {
          thiss.firstname = doc.data().firstname;
          thiss.lastname = doc.data().lastname;
          thiss.email = doc.data().email;
          thiss.mobile_phone = doc.data().mobile_phone;
          thiss.assigned_broker = doc.data().assigned_broker;
          let getassigned_broker = thiss.addLoanAdminForm.get('assigned_broker');
          getassigned_broker.setValue(thiss.assigned_broker);
          getassigned_broker.updateValueAndValidity();
          console.log(thiss.assigned_broker);
          thiss.selectedBrokers = thiss.assigned_broker;
        }
      }).catch(function(error) {
        console.log("Error getting document:", error);
      });
    }
    this.getAllBrokers().subscribe((data)=>{
      this.allBrokers = data;
    });
  }

  slectMultipleBroker(event){
    console.log(event);
    if(event.length){
      this.selectedBrokers = event;
    }else{
      this.selectedBrokers = null;
    }
  }

  getAllBrokers (){
    return this.db.collection<any>( "users" , ref => ref.where('roles.broker','==',true )).valueChanges ();
  }

  isFieldValid(field: string) {
    return !this.addLoanAdminForm.get(field).valid && this.addLoanAdminForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  add_loan_admin(){
    if(!this.addLoanAdminForm.valid){
      this.addLoanAdminForm.get('lastname').markAsDirty();
      this.addLoanAdminForm.get('lastname').markAsTouched();

      this.addLoanAdminForm.get('firstname').markAsDirty();
      this.addLoanAdminForm.get('firstname').markAsTouched();

      this.addLoanAdminForm.get('mobile_phone').markAsDirty();
      this.addLoanAdminForm.get('mobile_phone').markAsTouched();

      this.addLoanAdminForm.get('email').markAsDirty();
      this.addLoanAdminForm.get('email').markAsTouched();

      this.addLoanAdminForm.get('password').markAsDirty();
      this.addLoanAdminForm.get('password').markAsTouched();

      this.addLoanAdminForm.get('assigned_broker').markAsDirty();
      this.addLoanAdminForm.get('assigned_broker').markAsTouched();
    }else{
      this.loadingProvider.startLoading();
      let uid = window.localStorage.getItem("uid");
      if(uid != null){
        let firstname = this.addLoanAdminForm.value.firstname;
        let lastname = this.addLoanAdminForm.value.lastname;
        let email = this.addLoanAdminForm.value.email;
        let mobile_phone = this.addLoanAdminForm.value.mobile_phone;
        let password = this.addLoanAdminForm.value.password;
        let assigned_broker = this.addLoanAdminForm.value.assigned_broker;

        var headers = new Headers();
        headers.append("Accept", 'application/json');
        headers.append('Content-Type', 'application/json' );
        const requestOptions = new RequestOptions({ headers: headers });

        let postData = {
          "uid": uid,
          "displayName": firstname,
          "email": email,
          "phoneNumber": "+6"+mobile_phone,
          "password": password,
          "firstname": firstname,
          "lastname": lastname,
          "mobile_phone": mobile_phone,
          "assigned_broker": assigned_broker,
          "created_date" : new Date().getTime(),
          "role" : "loan_admin"
        }
        if(this.edit_contact_uid == null || this.edit_contact_uid == undefined || this.edit_contact_uid == ""){
          postData['edit_contact_uid'] = '';
        }else{
          postData['edit_contact_uid'] = this.edit_contact_uid;
        }
        var url = this.EnvDataService.EnvData.sendbox_api+"/createRoleAdmin";

        this.http.post(url, postData, requestOptions)
        .subscribe(data => {
          if(data['_body'] == 'The email address is already in use by another account.'){
            this.loadingProvider.stopLoading();
            this.presentToast(data['_body']);
          }else if(data['_body'] == 'The user with the provided phone number already exists.'){
            this.loadingProvider.stopLoading();
            this.presentToast(data['_body']);
          }else if(data['_body'] == 'TOO_LONG'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'TOO_SHORT'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'Invalid format.'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else if(data['_body'] == 'The phone number must be a non-empty E.164 standard compliant identifier string.'){
            this.loadingProvider.stopLoading();
            this.presentToast('Invalid Phone Number.');
          }else{
            this.loadingProvider.stopLoading();
            this.navCtrl.push(LoanAdminPage);
          }
        }, error => {
          this.loadingProvider.stopLoading();
          this.presentToast(error.message);
        });
      }
    }
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  ionViewDidLoad() {
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/add-loan-admin/add-loan-admin.ts